import store from 'utils/store/withMiddleware'
import stickySummary from '../components/plan-summary/sticky'

function handleToggleVision(event) {
  event.preventDefault()

  const state = store.getState()

  const addOns = [state.latitudeId, state.supplementalId, state.dentalPlanId].filter(
    Boolean
  )

  const canAddVision = state.dentalPlanId !== undefined

  if (this.checked && canAddVision) {
    store.update({
      addOns: addOns.concat(
        this.getAttribute('value')
          .split(',')
          .map(id => +id)
      )
    })
  } else {
    store.update({
      addOns: addOns
    })
  }

  stickySummary()
}

export default handleToggleVision
